
    export const CreateNewButtonStyles = {
        marginTop: "15px",
        marginRight: "auto"
    }
    export const ButtonGridWidthStyles = {
        width: "90%",
        marginTop: '24px'
    }
    export const PageTitleStyles = {
        fontSize: "20px"
    }
    export const CreateVAPageTitleStyles = {
        marginRight: "auto",
        fontSize: "18px",
        marginTop: "10px",
        marginLeft: "-12vw"
    }
    export const ReminderEntryStyles = {
        fontSize: "0.875rem",
        color: "black !important",
        marginTop: "5px"
    }
    export const ReminderTitleStyles = {
        position: "absolute",
        fontSize: "0.875rem",
        fontWeight: "800"
    }
    export const ReminderDividerStyles = {
        position: "relative",
        paddingTop: "23px"
    }
    export const ReminderDateInputStyles = {
        width: "80%",
        marginLeft: "30px",
        color: "black !important"
    }
    export const ReminderAddButtonStyles = {
        marginTop: "auto",
        marginBottom: "6px"
    }
    export const VisitorFormStyles = {
        marginTop: "30px",
        maxWidth: "1275px"
    }
    export const VisitorFormBStyles = {
        marginTop: "30px",
        maxWidth: "1275px"
    }
    export const VisitorFormBExtraSmallStyles = {
        maxWidth: "1275px"
    }
    export const ReminderVisitDetailsStyles = {
        maxWidth: "940px"
    }
    export const FunctionDetailsSmallStyles = {
        marginTop: "10px"
    }
    export const FunctionNameSmallStyles = {
        fontSize: "15px"
    }
    export const OptionLabelStyles = {
        fontSize: "12px"
    }
    export const DatesStyles = {
        paddingLeft: "90px"
    }
    export const DatesSmallStyles = {
        paddingLeft: "45px"
    }
    export const DatesExtraSmallStyles = {
        marginTop: "10px"
    }
    export const DatesPhoneStyles = {
        marginTop: "30px",
        marginLeft: "15vw"
    }
    export const DatePhoneBetweenStyles = {
        marginTop: "5px"
    }
    export const VisitorBoxStyles = {
        marginTop: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "180px"
    }
    export const VisitorBoxPhoneStyles = {
        marginTop: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "180px"
    }
    export const VisitorBoxMedStyles = {
        marginTop: "20px",
        marginLeft: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "180px"
    }
    export const VisitorBoxSmallerStyles = {
        marginTop: "20px",
        marginLeft: "15px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "180px"
    }
    export const VisitorBoxExtraSmallStyles = {
        marginTop: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "180px"
    }
    export const VisitorFormTopLandscapeStyles = {
        marginTop: "35px"
    }
    export const ConfirmationDialogLandscapeStyles = {
        marginTop: "10px"
    }
    export const VisitDetailsLandscapeStyles = {
        marginTop: "25px"
    }
    export const ReminderDialogLandscapeStyles = {
        marginTop: "30px"
    }
    export const ReminderBoxStyles = {
        marginTop: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "240px",
        marginRight: "5px"
    }
    export const ReminderToggleBoxStyles = {
        marginTop: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "120px",
        marginLeft: "5px",
        paddingBottom: "10px"
    }
    export const ReminderToggleBox600SmallStyles = {
        marginTop: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "120px",
        marginLeft: "13vw",
        paddingBottom: "10px"
    }
    export const ReminderDatePickerStyles = {
        marginTop: "auto",
        marginBottom: "5px",
        marginLeft: "7px",
        color: "black !important"
    }
    export const HostBoxStyles = {
        marginTop: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "170px"
    }
    export const VisitorBoxInputsStyles = {
        marginTop: "auto",
        marginBottom: "5px",
        marginLeft: "7px"
    }
    export const AddVisitorButtonStyles = {
        marginTop: "auto",
        marginBottom: "7px",
        marginLeft: "7px"
    }
    export const AddVisitorButtonMedStyles = {
        marginTop: "auto",
        marginBottom: "7px",
        marginLeft: "10px"
    }
    export const AddVisitorButtonSmallStyles = {
        marginTop: "auto",
        marginBottom: "7px",
        marginLeft: "5px"
    }
    export const FunctionBoxInputsStyles = {
        marginTop: "auto",
        marginBottom: "5px",
        marginLeft: "18px"
    }
    export const FunctionBoxInputsMedStyles = {
        marginTop: "auto",
        marginBottom: "5px",
        marginLeft: "10px"
    }
    export const FunctionBoxInputsPhoneStyles = {
        marginTop: "auto",
        marginBottom: "5px",
        marginLeft: "0px"
    }
    export const ReminderSwitchLabelStyles = {
        fontSize: "0.875rem",
        fontFamily: "Century !important",
        marginTop: "7px",
        marginLeft: "20px",
        width: "80%",
        color: "black !important"
    }
    export const ReminderSwitchLabelMedStyles = {
        fontSize: "0.875rem",
        fontFamily: "Century !important",
        marginTop: "7px",
        marginLeft: "15px",
        width: "80%",
        color: "black !important"
    }
    export const ReminderSwitchLabelSmallStyles = {
        fontSize: "0.875rem",
        fontFamily: "Century !important",
        marginTop: "7px",
        marginLeft: "7px",
        width: "80%",
        color: "black !important"
    }
    export const ReminderSwitchStyles = {
        paddingRight: "20px"
    }
    export const HostInnerStyles = {
        minHeight: "130px"
    }
    export const VisitorInnerStyles = {
        minHeight: "170px"
    }
    export const FunctionBoxStyles = {
        border: "solid 5px",
        borderRadius: "16px",
        maxWidth: "300px",
        maxHeight: "150px",
        marginLeft: "90px",
        marginRight: "20px",
        paddingTop: "9px",
        paddingBottom: "9px",
        marginBottom: "auto",
        marginTop: "55px"
    }
    export const FunctionBoxMedStyles = {
        border: "solid 5px",
        borderRadius: "16px",
        maxWidth: "300px",
        maxHeight: "150px",
        marginLeft: "20px",
        marginRight: "20px",
        paddingTop: "9px",
        paddingBottom: "9px",
        marginBottom: "auto",
        marginTop: "55px"
    }
    export const FunctionBoxExtraSmallStyles = {
        border: "solid 5px",
        borderRadius: "16px",
        maxWidth: "300px",
        maxHeight: "150px",
        marginLeft: "20px",
        paddingTop: "9px",
        paddingBottom: "9px",
        marginBottom: "auto",
        marginTop: "35px"
    }
    export const FunctionBoxPhoneStyles = {
        border: "solid 5px",
        borderRadius: "16px",
        maxWidth: "100%",
        maxHeight: "150px",
        marginLeft: "5px",
        paddingLeft: "15px",
        paddingTop: "9px",
        paddingBottom: "9px",
        marginBottom: "auto",
        marginTop: "10px"
    }
    export const NoVisitorsStyles = {
        paddingTop: "20px",
        fontSize: "15px",
        fontStyle: "italic"
    }
    export const NoRemindersStyles = {
        fontSize: "15px",
        fontStyle: "italic"
    }
    export const ConfRoomBoxStyles = {
        marginTop: "20px",
        marginLeft: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "170px"
    }
    export const ConfRoomBoxSmallStyles = {
        marginTop: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "170px"
    }
    export const ConfRoomBoxExtraSmallStyles = {
        marginTop: "20px",
        marginLeft: "20px",
        border: "solid 1px",
        borderRadius: "6px",
        minHeight: "170px"
    }
    export const SaveButtonStyles = {
        border: "3px solid",
        marginTop: "50px",
        marginRight: "5px",
        fontWeight: "900",
        fontSize: "16px",
        borderRadius: "12px"
    }
    export const SaveReminderButtonStyles = {
        border: "2px solid",
        marginRight: "10px",
        fontWeight: "900",
        fontSize: "16px",
        borderRadius: "12px"
    }
    export const ReminderInfoStyles = {
        marginLeft: "10px",
        marginTop: "10px"
    }
    export const ConferenceRoomInfoStyles = {
        marginLeft: "3px",
        paddingTop: "3px"
    }
    export const ReminderInfoSuggStyles = {
        marginLeft: "3px",
        marginTop: "1px",
        paddingTop: "3px"
    }
    export const ReminderInfoCustomStyles = {
        paddingTop: "3px",
        marginTop: "1px"
    }
    export const BackButtonStyles = {
        border: "1px solid",
        borderRadius: "6px",
        marginBottom: "7px",
        marginRight: "auto",
        marginLeft: "10vw"
    }
    export const BackButtonMainStyles = {
        marginRight: "auto",
        marginLeft: "7vw"
    }
    export const VisitorFormTopPhoneStyles = {
        marginLeft: "10vw"
    }
    export const BackButtonSmallerStyles = {
        border: "1px solid",
        borderRadius: "6px",
        marginBottom: "7px",
        marginRight: "auto",
        marginLeft: "5vw"
    }
    export const BackButtonPhoneStyles = {
        border: "1px solid",
        borderRadius: "6px",
        marginBottom: "7px",
        marginRight: "auto",
        marginLeft: "7px"
    }
    export const SaveInfoTipStyles = {
        marginTop: "45px",
        marginLeft: "5px"
    }
    export const ReminderInfoTipStyles = {
        marginTop: "38px",
        marginLeft: "5px"
    }
    export const DetailsRemindNowButtonStyles = {
        marginTop: "30px",
        marginLeft: "15px",
        marginRight: "5px",
        border: "2px solid",
        fontWeight: "900",
        borderRadius: "10px"
    }
    export const BackToVAFeedStyles = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        marginTop: "30px"
    }
    export const VisitorEntryStyles = {
        marginTop: "5px"
    }
    export const VisitorLabelStyles = {
        marginTop: "3px"
    }
    export const ConfDateInputsStyles = {
        marginBottom: "14px"
    }
    export const BoxLabelStyles = {
        position: "relative",
        paddingLeft: "5px",
        fontWeight: "800",
        fontSize: "0.875rem",
        fontFamily: ["Century !important"].join(",")
    }
    export const ReminderLabelStyles = {
        paddingLeft: "5px",
        fontWeight: "800",
        fontSize: "0.875rem",
        fontFamily: ["Century !important"].join(",")
    }
    export const AddHostButtonStyles = {
        marginTop: "auto",
        marginBottom: "6px",
        marginLeft: "13px"
    }
    export const AddHostButtonSmallStyles = {
        marginTop: "auto",
        marginBottom: "6px",
        marginLeft: "2px"
    }
    export const AddHostButtonPhoneStyles = {
        marginTop: "auto",
        marginBottom: "6px",
        marginLeft: "10px"
    }
    export const AddHostButtonSmallPhoneStyles = {
        marginTop: "auto",
        marginBottom: "6px",
        marginLeft: "20px"
    }
    export const AddConfButtonSmallStyles = {
        marginTop: "auto",
        marginBottom: "6px",
        marginLeft: "7px"
    }
    export const ConfRoomEntryStyles = {
        marginTop: "8px"
    }
    export const ThankYouStyles = {
        fontSize: "22px",
        fontWeight: "bold"
    }
    export const SuccessStyles = {
        paddingTop: "10px",
        fontSize: "18px"
    }
    export const StartChangedStyles = {
        fontSize: "15px"
    }
    export const SubmitPageContainerStyles = {
        paddingTop: "10%"
    }
    export const notchedOutlineStyles = {
        borderWidth: "1px",
        borderColor: "grey !important"
    }
    export const floatingLabelFocusStyleStyles = {
        color: "grey !important"
    }
    export const TextColorStyles = {
        color:
            (theme) => theme.palette.mode === "dark"
                ? "white !important"
                : "black !important"
    }
    export const CalendarIconColorStyles = {
        color:
            (theme) => theme.palette.mode === "dark"
                ? "#717073 !important"
                : "black !important"
    }
    export const RemindTextColorStyles = {
        color: "black !important"
    }
    export const CalendarBoxStyles = {
        display: "inline-block",
        width: "60px",
        height: "75px",
        border: "solid 3px",
        borderRadius: "16px",
        textAlign: "center",
        padding: "5px"
    }
    export const CalendarDateStyles = {
        fontSize: "17px",
        fontWeight: "bold",
        color: "darkblack"
    }
    export const CalendarMonthStyles = {
        fontSize: "15px",
        fontWeight: "bold",
        color: "darkblack"
    }
    export const CalendarYearStyles = {
        fontSize: "12px",
        fontWeight: "bold",
        color: "darkblack"
    }
    export const CalendarTimeBoxStyles = {
        display: "inline-block",
        width: "70px",
        height: "60px",
        border: "solid 2px",
        borderRadius: "16px",
        textAlign: "center",
        paddingTop: "5px"
    }
    export const CalendarTimeDateStyles = {
        fontSize: "18px",
        fontWeight: "bold",
        color: "darkblack"
    }
    export const CalendarTimeMonthStyles = {
        fontSize: "15px",
        fontWeight: "bold",
        color: "darkblack"
    }
    export const CalendarTimeStyles = {
        fontSize: "12px",
        fontWeight: "bold",
        color: "darkblack",
        paddingTop: "3px"
    }
    export const CalendarCellStyles = {
        marginRight: "30px",
        width: "80%"
    }
    export const ReminderTitleCenterStyles = {
        marginTop: "15px"
    }
    export const ReminderCardsStyles = {
        marginRight: "5px",
        marginLeft: "5px",
        marginBottom: "5px",
        [(theme) => theme.breakpoints.down("400")]: {
            marginTop: "5px"
        }
    }
    export const ReminderScrollStyles = {
        display: "flex",
        flexWrap: "nowrap",
        overflowX: "auto",
        maxWidth: "400px",
        "&::-webkit-scrollbar": {
            height: "5px"
        },
        "&::-webkit-scrollbar-track": {
            boxShadow: "inset 0 0 2px rgba(0,0,0,0.00)",
            webkitBoxShadow: "inset 0 0 10px rgba(0,0,0,0.00)"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#959399",
            height: "10px",
            borderRadius: "5px"
        }
    }
    export const VisitorAnnouncementListStyles = {
        marginTop: "50px",
        maxWidth: "740px"
    }
    export const VAListItemStyles = {
        marginBottom: "20px",
        height: "75px"
    }
    export const PaperItemStyles = {
        height: "75px"
    }
    export const PaperFirmNameStyles = {
        fontWeight: "bold"
    }
    export const PaperDetailsButtonsStyles = {
        height: "100%"
    }
    export const DetailButtonStyles = {
        marginBottom: "auto",
        width: "90%"
    }
    export const DetailButtonSmallStyles = {
        marginBottom: "auto",
        marginRight: "10px",
        width: "75%"
    }
    export const VisitDetailsTitleSmallStyles = {
        paddingTop: "15px"
    }
    export const VisitDetailsTitleStyles = {
        paddingTop: "0px"
    }
    export const VABoxGridStyles = {
        marginTop: "7px"
    }
    export const SearchBarStyles = {
        marginTop: "15px"
    }
    export const VisitDetailsTopSmallStyles = {
        width: "90%"
    }
    export const VisitDetailsTopStyles = {
        marginLeft: "85px",
        marginRight: "85px",
        width: "90%"
    }
    export const VisitDetailsEndStyles = {
        width: "93%"
    }
    export const FunctionIconYesNoStyles = {
        marginTop: "5px"
    }
    export const DetailsSpacingButtonStyles = {
        marginLeft: "10px",
        marginRight: "10px",
        borderRadius: "10px"
    }
    export const DetailsSpacingButtonSmallStyles = {
        marginTop: "5px",
        marginBottom: "5px",
        borderRadius: "10px"
    }
    export const SuccessReminderEmailStyles = {
        backgroundColor: "#717073",
        color: "#ffffff",
        fontSize: "18px",
        fontWeight: "600",
        textAlign: "center"
    }
    export const SuccessReminderEmailIconStyles = {
        fontSize: "18px",
        fontWeight: "600",
        textAlign: "center"
    }
    export const DeleteConfirmMsgStyles = {
        fontSize: "16px"
    }
    export const DeleteEmailMsgStyles = {
        fontSize: "15px"
    }
    export const DeleteEmailDisplayStyles = {
        fontSize: "14px",
        color: "#717073"
    }
    export const DisabledDeleteConfirmButtonStyles = {
        backgroundColor: "#bfbec2"
    }
